/**
 * `/edo/requests/:id` — путь, который бэк кладёт в `notification.link` и в ссылки писем
 * (`new URL(link, portalUrl)`). Карточка документа во фронте живёт на `/processes/:id`,
 * поэтому здесь только редирект: без него письмо открывало «Unmatched Route».
 */
import { Redirect, useLocalSearchParams } from 'expo-router'

export default function EdoRequestRedirect() {
  const { id } = useLocalSearchParams<{ id: string }>()
  return <Redirect href={{ pathname: '/processes/[id]', params: { id: String(id ?? '') } }} />
}
